import cryptoJs from "crypto-js";
import encBase64 from "crypto-js/enc-base64";

var CryptoJS = require("crypto-js");
const _encrypt = props => {
    try {
        const msg = CryptoJS.enc.Utf8.parse(props);
        const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPT_KEY);
        const iv = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_CRYPT_KEY);
        const enc = CryptoJS.AES.encrypt(msg, key, {
            iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            feedbacksize: 128
        });
        return enc.ciphertext.toString(encBase64);
    } catch (err) {
        return null;
    }
}

export default _encrypt;